import React, { Component } from 'react';
import MenuItem from '@material-ui/core/MenuItem';

import makeTrashable from 'trashable';

export default class LoadableList extends Component {
  static defaultProps = {
    // Load suggestions only once
    once: false,
    onLoad: Function.prototype,
    onFilter: Function.prototype
  }

  state = {
    // Copy of received `items` from backend
    tempItems: [],
    // Items to be rendered as suggestions
    items: [],
    // State if already loaded data once
    loadedOnce: false,
  };

  constructor(props) {
    super(props);

    this.createLoader();
  }

  componentDidMount() {
    this.load();
  }

  componentWillUnmount() {
    this.loader.trash();
  }

  createLoader() {
    this.loader && this.loader.trash();
    return this.loader = makeTrashable(this.props.loader(this.props.query));
  }

  shouldLoad() {
    return this.props.once ? !this.state.loadedOnce : true;
  }

  load() {
    const { itemToString, query } = this.props;

    // Prefilter results of the previous suggestions to prevent slow connections wait until receive
    // new suggestions on list.
    // `tempItems` are set when new data is received as suggestions.
    const filteredItems = [].concat(this.state.tempItems
      .filter(x => itemToString(x)
        .toLowerCase()
        .includes(query.toLowerCase())
      )
    );

    this.setState({ items: filteredItems }, this.props.onFilter(filteredItems));

    // Also saves a copy of array on `tempItems` when user query for a new input and the new
    // suggestions are not yet loaded. Used by the previous `setState`.
    //
    // Only loads info
    this.shouldLoad() && this.createLoader().then((items = []) => this.setState(
      { tempItems: items, items, loadedOnce: true },
      this.props.onLoad(items)
    ));
  }

  componentDidUpdate(prev) {
    const queryChanged = prev.query !== this.props.query;
    const dirtyChanged = prev.dirty !== this.props.dirty;

    if (queryChanged || dirtyChanged) {
      dirtyChanged && this.setState({ tempItems: [] });
      this.load();
    }
  }

  render() {
    const {
      highlightedIndex,
      selectedItem,
      getItemProps,
      itemToString,
      itemUniqueId
    } = this.props;

    return <div style={{maxHeight: '30vh', overflow: 'auto'}}>
      {
        this.state.items.map((suggestion, index) => {
          const highlighted = highlightedIndex === index;
          const isSelected = itemUniqueId(selectedItem) === itemUniqueId(suggestion);

          return (
            <MenuItem
              key={index}
              selected={highlighted}
              disabled={suggestion.disabled}
              style={{fontWeight: isSelected ? 'bold' : 'normal'}}
              {...getItemProps({ item: suggestion })}
            >
              {suggestion && itemToString(suggestion)}
            </MenuItem>
          );
        })
      }
    </div>;
  }
}
